// debounce code retrieved from: 
// https://stackoverflow.com/questions/24004791/what-is-the-debounce-function-in-javascript
export const debounce = (func, timeout = 300, immediate ) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }